// extracted by mini-css-extract-plugin
module.exports = {"title":"fonts_title__Cg6oD","subtitle":"fonts_subtitle__rAXgC","header":"fonts_header__uh6FR","tagline":"fonts_tagline__YZU8F","button":"fonts_button__SVBnh"};